import axiosInstance from "../../axiosInstance";

const BASE_URL = "/hrm/positions";

// Lấy danh sách chức vụ theo chi nhánh
export const getPositionsByBranch = async (branchId) => {
  try {
    const res = await axiosInstance.get(BASE_URL, {
      params: { branch_id: branchId },
    });
    return res.data;
  } catch (error) {
    console.error("Lỗi getPositionsByBranch:", error?.response || error);
    throw error;
  }
};

